import { useTranslation } from "next-i18next";
export function resolveMessage(productTitle, variantTitle, isComingSoon, waitlistMessage) {
  const { t } = useTranslation("productpage");
  if (waitlistMessage) {
    return waitlistMessage;
  }
  if (isComingSoon) {
    return "Coming soon";
  }
  return ` ${t("find-out")} ${productTitle} (${variantTitle.replace(" / ", "/")}) ${t(
    "is-available"
  )}.`;
}
